import { createEphemeralWebSocket } from "./use-socket-ephemeral";
export function createExternalPermissionSocket(centerId: string, staffMemberId: string) {
  const ws = createEphemeralWebSocket("EXTERNAL_PERMISSIONS", centerId, staffMemberId);

  const ready = new Promise<void>((resolve, reject) => {
    ws.addEventListener("open", () => resolve(), { once: true });
    ws.addEventListener("error", e => reject(e), { once: true });
  });

  const completed = new Promise<unknown>((resolve, reject) => {
    const timeout = setTimeout(() => {
      ws.close();
      reject(new Error("WebSocket timed out"));
    }, 15000);

    ws.addEventListener(
      "message",
      evt => {
        clearTimeout(timeout);
        ws.close();
        try {
          const eventData = JSON.parse(evt.data);
          const responseCode = eventData.responseCode;

          const toastMsg = eventData.message;

          const toastType = responseCode === 200 ? "info" : "danger";

          resolve(eventData);

          window.toasts.add({
            content: toastMsg,
            type: toastType
          });
        } catch (e) {
          reject(e);
        }
      },
      { once: true }
    );

    ws.addEventListener(
      "close",
      evt => {
        clearTimeout(timeout);
        if (!evt.wasClean) {
          reject(new Error(`WS closed unexpectedly: ${evt.code}`));
        }
      },
      { once: true }
    );
  });

  const close = () => {
    if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
      ws.close();
    }
  };

  return { ws, ready, completed, close };
}
